export const GET_TENANT_DETAIL_REQUEST = "GET_TENANT_DETAIL_REQUEST";
export const GET_TENANT_DETAIL_SUCCESS = "GET_TENANT_DETAIL_SUCCESS";
export const GET_TENANT_DETAIL_ERROR = "GET_TENANT_DETAIL_ERROR";

export const GET_TENANTS_LIST_REQUEST = "GET_TENANTS_LIST_REQUEST";
export const GET_TENANTS_LIST_SUCCESS = "GET_TENANTS_LIST_SUCCESS";
export const GET_TENANTS_LIST_ERROR = "GET_TENANTS_LIST_ERROR";

export const DELETE_TENANT_ROW_REQUEST = "DELETE_TENANT_ROW_REQUEST";
export const DELETE_TENANT_ROW_SUCCESS = "DELETE_TENANT_ROW_SUCCESS";
export const DELETE_TENANT_ROW_ERROR = "DELETE_TENANT_ROW_ERROR";

export const UPDATE_TENANT_ROW_REQUEST = "UPDATE_TENANT_ROW_REQUEST";
export const UPDATE_TENANT_ROW_SUCCESS = "UPDATE_TENANT_ROW_SUCCESS";
export const UPDATE_TENANT_ROW_ERROR = "UPDATE_TENANT_ROW_ERROR";

export const UPDATE_USER_V2_ROW_REQUEST = "UPDATE_USER_V2_ROW_REQUEST";
export const UPDATE_USER_V2_ROW_SUCCESS = "UPDATE_USER_V2_ROW_SUCCESS";
export const UPDATE_USER_V2_ROW_ERROR = "UPDATE_USER_V2_ROW_ERROR";


export const DELETE_USER_V3_ROW_REQUEST = "DELETE_USER_V3_ROW_REQUEST";
export const DELETE_USER_V3_ROW_SUCCESS = "DELETE_USER_V3_ROW_SUCCESS";
export const DELETE_USER_V3_ROW_ERROR = "DELETE_USER_V3_ROW_ERROR";
